const DEFAULT_VALUES = {
  amount: 180000,
  duration: 10,
  occasions: 120,
  interest: 7.95,
  effectiveInterest: 8.25,
  totalCost: 261497,
  monthlyCost: 2179,
  startupFee: 0,
  monthlyFee: 0,
  cost: 66915,
  date: '2023-11-01'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const INTEREST = 5.95

// ? ******************************************************************************************
// ? ******************************************************************************************

const INTERESTS = [
  {
    amount: 0,
    interestRate: 5.95,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 20000,
    interestRate: 5.95,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 100000,
    interestRate: 5.95,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 175000,
    interestRate: 5.95,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 300000,
    interestRate: 5.95,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 500000,
    interestRate: 5.95,
    startupFee: 0,
    monthlyFee: 0
  }
]

// ? ******************************************************************************************
// ? ******************************************************************************************

const DISCLAIMER = {
  sv: '<p>Räntan är rörlig och sätts individuellt. För ett annuitetslån på {amount} med {duration} års löptid, nominell ränta {interest} med {startupFee} i startavgift/aviavgift blir den effektiva räntan {effectiveInterest}. Totalt belopp att betala {totalCost} fördelat på {occasions} avbetalningar ger en månadskostnad på {monthlyCost}. Uppdaterat {date}.</p><p>Återbetalningstid {minDuration}-{maxDuration} år. Maximala räntan är 29,4 %. Räntespann 5,2-29,4 %</p>' + '<p>Din ansökan skickas till de kreditgivare som bäst matchar din profil</p>',
  en: '<p>The interest rate is variable and is set individually. For an annuity loan of {amount} with {duration} yrs term, nominal interest {interest} with {startupFee} in start-up fee/aviation fee, the effective interest becomes {effectiveInterest}. Total amount to pay {totalCost} divided by {occasions} installments gives a monthly cost of {monthlyCost}. Updated {date}.</p><p>Repayment period {minDuration}-{maxDuration} yrs. The maximum interest rate is 29.40%. Interest range 5.2-29.40%</p>' + '<p>Your application is sent to the lenders that best match your profile</p>'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

module.exports = {
  DEFAULT_VALUES,
  INTEREST,
  INTERESTS,
  DISCLAIMER
}
